import {PaymentProvider} from "../generated/graphql";
import {PaymentMethodType} from "./getPaymentMethodType";

type ProviderSettingLike = {
    bankTransferProvider?: PaymentProvider | null;
    sepaDebitProvider?: PaymentProvider | null;
};

export const getProviderForPaymentMethodType = (
    paymentMethodType: PaymentMethodType,
    setting: ProviderSettingLike | undefined,
): PaymentProvider | undefined => {
    if (!setting) {
        return undefined;
    }

    if (paymentMethodType === "bankTransfer") {
        return setting.bankTransferProvider || PaymentProvider.Manual;
    }

    if (paymentMethodType === "sepaDebit") {
        return setting.sepaDebitProvider || PaymentProvider.Manual;
    }

    return undefined;
};
